<template>
  <div />
</template>

<script>
export default {
  name: "SystemTop",
  mounted() {
    this.$store.commit("loading/setLoading", false)
    window.location.href = this.$config.app.yoshidaTop
  }
}
</script>
